import { ColumnMapping } from '@/components/ExcelExportModal'

export const EMPLOYEE_INCOME_EXCEL_COLUMNS: ColumnMapping[] = [
    { header: 'customer_id', data_field: 'customer_id', width: 15 },
    { header: 'customer_name', data_field: 'customer_name', width: 30 },
    { header: 'company_name', data_field: 'customer_company_name', width: 35 },
    { header: 'service_id', data_field: 'service_id', width: 15 },
    {
        header: 'service_start_date',
        data_field: 'service_start_date',
        width: 15,
        formatter_type: 'date',
        formatter_options: { date_format: 'MM/YYYY' },
    },
    { header: 'service_name', data_field: 'service_name', width: 25 },
    {
        header: 'product_group_name',
        data_field: 'product_group_name',
        width: 25,
    },
    { header: 'invoice_id', data_field: 'invoice_id', width: 15 },
    { header: 'invoice_item_name', data_field: 'invoice_item_name', width: 30 },
    {
        header: 'invoice_item_description',
        data_field: 'invoice_item_description',
        width: 40,
    },
    {
        header: 'invoice_item_start_date',
        data_field: 'invoice_item_start_date',
        width: 20,
        formatter_type: 'date',
    },
    {
        header: 'invoice_item_end_date',
        data_field: 'invoice_item_end_date',
        width: 20,
        formatter_type: 'date',
    },
    {
        header: 'invoice_item_amount',
        data_field: 'invoice_item_amount',
        width: 20,
        formatter_type: 'currency',
    },
    {
        header: 'invoice_item_taxable',
        data_field: 'invoice_item_taxable',
        width: 15,
    },
    {
        header: 'total_with_vat',
        data_field: 'total_with_vat',
        width: 20,
        formatter_type: 'currency',
    },
    {
        header: 'payment_date',
        data_field: 'payment_date',
        width: 20,
        formatter_type: 'date',
    },
    { header: 'employee_names', data_field: 'employee_names', width: 35 },
    { header: 'employee_codes', data_field: 'employee_codes', width: 20 },
    { header: 'service_type', data_field: 'service_type', width: 20 },
    { header: 'is_renewal', data_field: 'is_renewal', width: 15 },
    {
        header: 'month_created_invoice',
        data_field: 'month_created_invoice',
        width: 20,
    },
    { header: 'kpi_type', data_field: 'kpi_type', width: 20 },
    { header: 'kpi_rate', data_field: 'kpi_rate', width: 20 },
    { header: 'commission', data_field: 'kpi_amount', width: 20 },
]
